import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';



@Component({
  selector: 'app-cmsmasterconfig',
  templateUrl: './cmsmasterconfig.component.html',
  styleUrls: ['./cmsmasterconfig.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],


})


export class CmsmasterconfigComponent implements OnInit {
  cmsmasterconfigform: FormGroup;
  submitted = false;


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.cmsmasterconfigform = this.formBuilder.group({

      soa: ['', Validators.required],
      claimfcode: ['',],
      revenuecode: ['',],
      placeofservice: ['',],
      dischargestatus: ['',],
      occurencecod: ['',],
      admittype: ['',],
      typeofbill: ['',],


    });
  }

  get f() { return this.cmsmasterconfigform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.cmsmasterconfigform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.cmsmasterconfigform.value))
  }
}


